import React, { useCallback } from 'react';
import { RouteComponentProps } from 'react-router';

import useCustomerCreates from 'core/hooks/useCustomerCreates';
import { CustomerFormSchema } from 'core/schemas/customerForm';
import { FormSubmitHandler } from 'Elements/Form';

import CustomerForm from './CustomerPage/CustomerForm';
import CustomerPage from './CustomerPage/CustomerPage';

export default function CustomerCreate({ history }: RouteComponentProps) {
  const create = useCustomerCreates();

  const onSubmit: FormSubmitHandler<CustomerFormSchema> = useCallback(
    (values, form) => {
      return create(values.customer)
        .then(customer => history.replace(`/customers/${customer.id}`))
        .catch(errors => form.setErrors({ customer: errors }));
    },
    [create, history]
  );

  return (
    <CustomerForm onSubmit={onSubmit}>
      <CustomerPage
        title="Luo uusi asiakas"
        subtitle="Perustietojen tallentamisen jälkeen voit lisätä käyttäjät, ajoneuvot ja tuotehinnaston"
      />
    </CustomerForm>
  );
}
